import React, {Component} from 'react'
import html2canvas from 'html2canvas'
import SupportModal from '../Support/SupportModal'

export default class SupportButton extends Component {

  constructor(props) {
    super(props)
    this.state = {
      isOpen: false,
      processing: false,
      screenshot_base64: null
    }

    this.onSupportClick = this.onSupportClick.bind(this)
  }

  onSupportClick(e) {
    e.preventDefault()
    e.stopPropagation()
    this.setState({processing: true})
    this.takeScreenshot()
  }

  takeScreenshot = () => {
    // html2canvas doesn't have full CSS support
    document.body.querySelector('.breadcrumb').dataset.html2canvasIgnore = 'true'
    document.body.style.cursor = 'wait'
    html2canvas(document.body, {
      logging: false,
      width: 1920,
      height: 1080,
      windowWidth: 1920,
      windowHeight: 1080,
      scale: 1,
      onclone: (doc) => {
        doc.body.querySelectorAll('.animated', '.fadeIn').forEach(a => a.classList.remove('animated', 'fadeIn'))
        doc.body.querySelectorAll('.card').forEach(a => a.style.width = '1470px')

        let asideEl = doc.body.querySelector('aside.aside-menu')
        asideEl.classList.remove('aside-menu')
        asideEl.style.position = 'absolute'
        asideEl.style.right = '0'
      }
    }).then((canvas) => {
      let imgData = canvas.toDataURL('image/jpeg', 0.5)
      this.setState({screenshot_base64: imgData, isOpen: true, processing: false})
      document.body.style.cursor = ''
    })
  }

  render() {
    let cursorStyle = this.state.processing ? {cursor: 'wait'} : {}
    return (
      <div>
        {this.state.isOpen &&
        <SupportModal
          onCancel={() => this.setState({isOpen: false, screenshot_base64: null})}
          screenShotFileData={this.state.screenshot_base64}
        />}
        <li className="nav-item" style={{zIndex: '1060'}}>
          <a className="nav-link" aria-current="false" href="" style={cursorStyle} onClick={this.onSupportClick}>
            <i className="fa fa-desktop fa-lg"></i>Support
          </a>
        </li>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Sidebar/SupportBtn.js